import { render, staticRenderFns } from "./RecordedUpload.vue?vue&type=template&id=2980eb10&"
import script from "./RecordedUpload.vue?vue&type=script&lang=ts&"
export * from "./RecordedUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports